import { memo, useEffect } from 'react';

import TopBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/TopBtn';
import HistoryBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/HistoryBtn';
import StyleClipAddBtn from '@wconcept/wconcept-ui-renewal/components/molecules/_btn/StyleClipAddBtn';

import * as S from './style';

interface IProps {
  btnTopShow?: boolean;
  isHistoryBtn?: boolean;
  isStyleClipAddBtn?: boolean;
  historyImg?: string;
  rs?: string;
  isShortFormBtnTooltip?: boolean;
  styleClipTooltipPoint?: number;
  setTooltipShown?: (value: string) => void;
  onClickTop?: () => void;
  onClickHistory?: () => void;
  onClickStyleClipAddBtn?: () => void;
  getHistoryImg?: () => void;
  isLogin?: boolean;
}

const FloatUtilsDesktop = ({
  btnTopShow = false,
  isHistoryBtn = true,
  isStyleClipAddBtn = false,
  historyImg,
  rs,
  isShortFormBtnTooltip,
  styleClipTooltipPoint,
  setTooltipShown,
  onClickTop,
  onClickHistory,
  onClickStyleClipAddBtn,
  getHistoryImg,
  isLogin,
}: IProps) => {
  useEffect(() => {
    const handlePopState = () => {
      if (getHistoryImg) getHistoryImg();
    };

    const handlePageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        if (getHistoryImg) getHistoryImg();
      }
    };

    window.addEventListener('popstate', handlePopState);
    window.addEventListener('pageshow', handlePageShow);

    getHistoryImg?.();

    return () => {
      window.removeEventListener('popstate', handlePopState);
      window.removeEventListener('pageshow', handlePageShow);
    };
  }, []);

  return (
    <S.FloatUtilsDesktop>
      <div className="inner-float-utils">
        <TopBtn
          className={`btn-top ${btnTopShow ? ' active' : ''}`}
          onClick={onClickTop}
        />
        {isHistoryBtn && (
          <HistoryBtn
            imgSrc={isLogin ? historyImg : ''}
            rs={rs}
            onClick={onClickHistory}
          />
        )}
        {isStyleClipAddBtn && (
          <StyleClipAddBtn
            onClick={onClickStyleClipAddBtn}
            styleClipTooltipPoint={styleClipTooltipPoint}
            isShortFormBtnTooltip={isShortFormBtnTooltip}
            setTooltipShown={setTooltipShown}
          />
        )}
      </div>
    </S.FloatUtilsDesktop>
  );
};

export default memo(FloatUtilsDesktop);
